import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-user-added-card',
  templateUrl: './user-added-card.component.html',
  styleUrls: ['./user-added-card.component.scss']
})
export class UserAddedCardComponent implements OnInit {

  @Input() fullName: string = '';
  @Input() email: string = '';
  @Input() imageURL: string = '';

  @Output() removeClicked: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  removeAddedUser() {
    this.removeClicked.emit(true);
  }

}
